export default "__VITE_ASSET__DcMkvWhY__"